import { type PartialUserContext } from '@common/defaults/UserContext';

import { SupertokensStatus } from './SupertokensStatus';
import { updateStatus } from './updateStatus';

export const getStatus = (userContext: PartialUserContext | undefined): SupertokensStatus => {
    if (!userContext?.supertokens) {
        return SupertokensStatus.UNKNOWN;
    }

    updateStatus(userContext);

    return userContext.supertokens.status;
};
